import React from 'react';
import './content-scroller.sass';

const ContentScroller = ({ children, height }) => (
  <div className="ContentScroller" style={{ height }}>
    {children}
  </div>
);

export default ContentScroller;
